
export const setCurrentBrandIfNotSet = (brand) => {
    if (localStorage.getItem("current_brand") === null) {
        localStorage.setItem("current_brand", JSON.stringify({id: brand.id, name: brand.name}) )
    }
}